'use client';

import { useEffect, CSSProperties, FC } from 'react';

// Define the type for props
interface AdBannerProps {
  className?: string;
  style?: CSSProperties;
  'data-ad-client'?: string;
  'data-ad-slot'?: string;
  'data-ad-format'?: string;
  'data-full-width-responsive'?: string;
}

// Extend the Window interface to include adsbygoogle
declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const MultiplexAdBanner: FC<AdBannerProps> = (props) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    // <ins
    //   className="adsbygoogle"
    //   style={{
    //     display: `block`,
    //     width: `100%`,
    //     height: `200px`,
    //   }}
    //   data-ad-client="ca-pub-3436497941634374"
    //   data-ad-slot="6182497133"
    //   data-ad-format="autorelaxed"
    //   data-full-width-responsive="data-full-width-responsive"
    // />
    <></>
  );
};

export default MultiplexAdBanner;
